import createAttachmentsApi from './provider';

const NEWS_ITEM_ATTACHMENT_TYPE_ID = 0;

const { get, add, edit, remove } = createAttachmentsApi(NEWS_ITEM_ATTACHMENT_TYPE_ID);
export { get, add, edit, remove };